// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PriceRangeFilter_wrap__xu1_r","line":"PriceRangeFilter_line__ORXE5","range":"PriceRangeFilter_range__pnnzc"};